import axios from 'axios';
import applyCaseMiddleware from 'axios-case-converter';

import { getTokenRedirect } from './msal';

// used to temporary bypass MSAL 2.0
export const djSessionId = null;
// export const djSessionId = 's1xslht0h0vzluoak8v3nzpriq7u2w2p';

export const imageUploadConfig = {
	uploadUrl: import.meta.env.VITE_REST_API_BASE_URL + 'image/',
	headers: {
		Authorization: `Bearer still not set`,
		accept: 'application/json, text/plain, */*',
		'content-disposition': 'attachment;filename="still not set"',
	},
};

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

export const restapi = applyCaseMiddleware(axios.create({
	baseURL: import.meta.env.VITE_REST_API_BASE_URL,  // must include '/api/v1/'
}));

restapi.interceptors.response.use(response => {
	return response;
}, (error) => {
	if (error.response && error.response.status === 403) {
		// do not call signIn to avoid loops
		// signIn();
		console.warn('403 Restapi connection forbidden', error);
	}
	return Promise.reject(error);
});

if (!djSessionId && !import.meta.env.VITE_TEST_MODE) {  // prevent this from being used in tests
	restapi.interceptors.request.use(async config => {
		// @ts-ignore
		const c = {headers: {}, ...config};
		const tokenResponse = await getTokenRedirect();
		if (tokenResponse) {
			c.headers['Authorization'] = `Bearer ${tokenResponse.accessToken}`;
			// also set the token for Editor image upload
			imageUploadConfig.headers['Authorization'] = `Bearer ${tokenResponse.accessToken}`;
		}
		return c;
	});
}

if (djSessionId) {  // set cookie
	document.cookie = `sessionid=${djSessionId}; path=/;`;
} else {  // clear cookie
	document.cookie = "sessionid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}